<template>
    <div>
        <template v-if="error">
            <div class="error" v-if="error">
                <p>{{$t('error')}}</p>
                <button type="button" @click="loadFirstResources">
                    {{$t('retry')}}
                </button>
            </div>
        </template>

        <div v-show="!error" class="carousel-wrapper">
            <div class="carousel" ref="carousel">
                <template v-if="loading" >
                    <slot name="loading">
                        <div
                            v-for="numb in perPage"
                            :key="numb"
                            class="slide"
                        >
                            <slot name="placeholder" :element="{}">
                            </slot>
                        </div>
                    </slot>
                </template>

                <template v-else>
                    <div
                        class="slideVertical"
                        v-for="resourceElement in elements"
                        :key="resourceElement.id"
                        v-if="elements.length"
                    >
                        <slot :element="resourceElement">
                            {{JSON.stringify(resourceElement)}}
                        </slot>
                      <hr/>
                    </div>

                    <p v-if="elements.length === 0">{{$t('noRecords')}}</p>
                    <div v-if="loadingMore" class="slide">
                        <Spinner v-if="loadingMore"/>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import Spinner from '../Spinner';
import EventBus from '../../eventbus';
import _ from 'lodash'
import VideoWatchBox from "./PostContainer/MovieContainer";

export default {
    components: {
        Spinner,
        VideoWatchBox
    },
    props: {
        resource: {
            type: Object,
            required: true,
        },
        params: {
            type: Object,
            required: false,
            default: () => ({})
        },
        defaultParams: {
            type: Object,
            required: false,
            default: () => ({})
        },
        perPage: {
            required: false,
            default: 4
        },
        showIfEmpty: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    data(){
        return {
            elements: [],
            loading: true,
            loadingMore: false,
            error: false,
            lastLoadedPage: null,
            paginationParams: {
                page: 1,
                per_page: this.perPage,
            },
            paginationMeta: {
                total: null,
                total_pages: null,
                count: null,
            },
            scrollData: {
                left: 0,
                right: 0,
                rightLimit: 0,
                leftLimit: 0,
                width: 0,
            },
            slideMovementTimeout: null,
            isEmpty: false,
        };
    },
    methods: {
        // proper implementation - do not use arrow function // debounce o throttle
        endOfScrollPageReached:_.throttle(function(){
            // console.log('BIP');
            this.loadMoreResources();
        }, 500),
        
        loadFirstResources(){
            //this.$emit('elementsCount', 0);

            this.elements = [];
            this.loading = true;
            this.loadingMore = false;
            this.error = false;
            this.lastLoadedPage = null;
            this.paginationParams = {
                page: 1,
                per_page: this.perPage,
            };

            this.paginationMeta = {
                total: null,
                total_pages: null,
                count: null,
            };

            this.addResources(Object.assign({}, this.defaultParams, this.params, this.paginationParams));
        },
        loadMoreResources(){
            this.loadingMore = true;
            this.addResources(Object.assign({}, this.defaultParams, this.params, this.paginationParams));
        },
        addResources(params){
            this.resource.index(params)
                .then((response) => {
                    this.loading = false;
                    this.loadingMore = false;
                    this.elements = this.elements.concat(response.data.data);
                    // remuevo duplicados
                    this.elements = this.elements.filter((value, index, self) =>
                      index === self.findIndex((t) => (
                        t.id === value.id
                      ))
                    )
                    this.paginationMeta = response.data.meta.pagination;
                    this.lastLoadedPage = params.page;

                }).catch(() => {
                    this.loading = false;
                    this.error = true;
                });
        },

        loadMoreForInfiniteScroll() {
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight;
                if (bottomOfWindow && !this.loading && this.paginationMeta.current_page < this.paginationMeta.total_pages) {
                    this.endOfScrollPageReached();
                }
            }
        }
    },
    watch: {
        'paginationParams.defaultParams': function(value){
            this.loadFirstResources();
        },
        'paginationParams.params': function(value){
            this.loadFirstResources();
        },
        'perPage': function(value){
            this.paginationParams.per_page = value;
        },
        'lastLoadedPage': function(value){
            if(value === null){
                this.paginationParams.page = 1;
            }else{
                this.paginationParams.page = value + 1;
            }
        },
        elements: {
            handler(){
                this.$emit('elementsCount', this.elements.length);
            },
            deep: true,
        }
    },
    mounted(){
        this.loadFirstResources();
        this.loadMoreForInfiniteScroll();
        EventBus.$on('languageChanged', () => {
            this.loadFirstResources();
        });
    },
    computed: {
    },
    beforeDestroy(){

    }

}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.slideVertical{
    width: 600px;
    max-width: 90%;
    min-height: 300px;
    margin: 30px 0;
  
  hr{
    border-color: #dcdcdc;
  }
}

.carousel-wrapper{
    position: relative;

    @media(min-width: 770px) and (max-width: 1440px){

    }

    &:focus{
        .arrow{
            .draw{
                opacity: 1;
            }
        }
    }

    .carousel{
        scroll-behavior: smooth;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        overflow-scrolling: touch;
        justify-content: flex-start;
        align-items: center;

        -ms-overflow-style: none;  /* IE 10+ */
        overflow: -moz-scrollbars-none; /* should hide scroll bar */
        overflow: hidden;

        &::-webkit-scrollbar{
            display: none; /*  might be enough */
            background: transparent;
            visibility: hidden;
            width: 0;
        }

        .slide{
            width: auto;
            flex: 0;

            &:hover{
                //background-color: #ff0000;
            }
        }
    }
}

.error{
    text-align: center;
}

.loading{
    text-align: center;
}
</style>